import script from "./ThankYou.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThankYou.vue?vue&type=script&setup=true&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=c73c17d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73c17d4"]])

export default __exports__